module.exports = __webpack_public_path__ + "img/quartz.6f4494a5.png";